import { Button } from '../components/ui/button';
import { Music, RefreshCw, Wrench } from 'lucide-react';
import { SUPPORT_CENTER_URL } from '../lib/support';

export default function Maintenance({ message = 'We are updating our servers right now. Please check back soon.' }) {
  return (
    <div className="min-h-screen overflow-hidden bg-[#080808] text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(0,112,243,0.24),rgba(8,8,8,0.96)_50%)]" />
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#66a8ff]/60 to-transparent" />
      <div className="relative mx-auto flex min-h-screen max-w-5xl flex-col items-center justify-center px-4 py-16 text-center sm:px-6 lg:px-8">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-white/5 shadow-[0_0_80px_rgba(0,112,243,0.18)]">
          <Music className="h-8 w-8 text-[#66a8ff]" />
        </div>
        <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-[#0070f3]/25 bg-[#0070f3]/10 px-4 py-1 text-xs font-semibold uppercase tracking-[0.22em] text-[#9cc7ff]">
          <Wrench className="h-3.5 w-3.5" />
          Maintenance mode
        </p>
        <h1 className="font-unbounded text-3xl font-black tracking-tight sm:text-5xl">
          We are updating our servers right now
        </h1>
        <p className="mt-4 max-w-2xl text-base leading-7 text-gray-300 sm:text-lg">
          {message}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button
            type="button"
            onClick={() => window.location.reload()}
            className="bg-[#0070f3] text-white hover:bg-[#328bf6]"
          >
            <RefreshCw className="mr-2 h-4 w-4" />
            Refresh
          </Button>
          <a href={SUPPORT_CENTER_URL}>
            <Button variant="outline" className="border-white/10 bg-white/5 text-white hover:bg-white/10">
              Contact support
            </Button>
          </a>
        </div>
        <p className="mt-10 text-xs uppercase tracking-[0.2em] text-gray-500">
          Thanks for your patience while we bring everything back online
        </p>
      </div>
    </div>
  );
}
